<template>
  <div class="wrapper" id="pricing-wrapper">
    <div class="card" v-if="!wasSent">
      <h2>Forgot Password?</h2>

      <div id="reset-password-wrapper">
        <input class="input"
          type="email"
          id="reset-password-email"
          v-model="email"
          placeholder="Your Email"
        />
        <button class="button button-primary button-right" @click="send">
          Reset Password
        </button>
      </div>

      <br />
      <router-link to="login"> Back To Login </router-link>
    </div>
    <h2 v-else>Please check your inbox!</h2>
  </div>
</template>

<script>
import { supabase } from "../supabase";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default {
  data() {
    return {
      email: "",
      wasSent: false,
    };
  },
  methods: {
    async send() {
      try {
        const { data, error } = supabase.auth.api.resetPasswordForEmail(
          this.email
        );

        if (error) {
          throw error;
        } else {
          
          this.wasSent = true;
        }
      } catch (error) {
        
        Toastify({
          text:
            "Password reset failed. Please try again. \n" +
              error.error_description ||
            error.message ||
            error,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top", // `top` or `bottom`
          position: "center", // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: "var(--primary-500)",
          },
          onClick: function () {}, // Callback after click
        }).showToast();
      }
    },
  },
};
</script>